module.exports = __webpack_public_path__ + "img/bg-stella-guan.85beb4bb.jpg";